module.exports = __webpack_public_path__ + "img/bike_stopped.fa01bdb8.svg";